import { render, staticRenderFns } from "./LoginInvest.vue?vue&type=template&id=cb7b31a4&scoped=true&"
import script from "./LoginInvest.vue?vue&type=script&lang=js&"
export * from "./LoginInvest.vue?vue&type=script&lang=js&"
import style0 from "./LoginInvest.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LoginInvest.vue?vue&type=style&index=1&id=cb7b31a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7b31a4",
  null
  
)

export default component.exports